import { Tabs } from "antd";
import React, { useState, useEffect } from "react";

export default ({ station, orTag, getStationId, needAll = true }) => {
  const stationIds = JSON.parse(sessionStorage.getItem("userInfo")).stationIds;
  const [items, setItems] = useState([]);

  useEffect(() => {
    const arr = station.map((item) => {
      return {
        label: item.aliasName || item.name,
        key: item.id,
      };
    });
    if (needAll) {
      arr.unshift({
        label: "全部",
        key: -1,
        children: "",
      });
    }
    setItems(arr);
  }, [station]);

  const handleModeChange = (e) => {
    if (e == "-1" && orTag) {
      getStationId(stationIds);
    } else if (e == "-1") {
      getStationId(null);
    } else {
      getStationId(e);
    }
  };

  return (
    <div className="area-tabs">
      <Tabs onChange={handleModeChange} items={items}></Tabs>
    </div>
  );
};
